import config from "config";

export const getPickupTimes = () => {
    const times = [];
    for (var i = 0; i < 24; i++) {
        let n = i;
        if (n < 10) {
            n = '0' + n;
        }
        times.push(n + ':00');
        times.push(n + ':30');
    }
    return times;
}

export const getCarrierTypeOptions = () => {
    const typeOptions = [
        { label: 'Parcel', value: 'Parcel' },
        { label: 'Freight', value: 'Freight' },
        { label: 'Van', value: 'Van' },
        { label: 'Driver', value: 'Driver' }
    ];
    return typeOptions;
}

export const isJsonString = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export const getUrlForPath = (path) => {
    if(path === '/'){
        path = '';
    }
    if(path.indexOf('/') === 0){
        path = path.substring(1, path.length);
    }
    return config.defaultPath + path;
}

export const trackConversion = (name, additionalOptions = {}) => {
    try{
        window.uetq = window.uetq || [];
        window.uetq.push('event', name, additionalOptions);
    }catch(e){

    }
    try{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'event': name});
    }catch(e){

    }

}